<template>
  <div class="projectParticulars">
    <header>
      <el-tooltip effect="dark" content="返回" placement="bottom">
        <button @click="backtrack" style="cursor:pointer" class="returnBtn">
          <i class="el-icon-back"></i>
        </button>
      </el-tooltip>
      <p>项目详情</p>
    </header>
    <div class="main_box">
      <div class="projectName">
        <div>
          <span class="formName">项目名称</span>
          <el-input v-model="projectName"></el-input>
        </div>
        <div>
          <span class="formName">交付时间</span>
          <div class="data_now">
            <el-date-picker v-model="deliveryTime" :editable="false" :clearable="false" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
            <el-time-select v-model="deliveryMinute" :editable="false" :clearable="false"
              :picker-options="{start: start,step: '00:30',end: '23:30'}" placeholder="选择时间">
            </el-time-select>
          </div>
        </div>
        <!-- <span class="domain">领域： {{ domain }}</span> -->

      </div>
      <div class="setBox_bottom">
        <div v-if="!standard">
          <div class="formName">项目流程</div>
          <template>
            <el-select v-model="projectValue" disabled placeholder="请选择">
              <el-option v-for="item in ProjectFlow" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </div>
        <div>
          <div class="formName">文件领域</div>
          <template>
            <el-select v-model="domain" disabled placeholder="请选择">
              <el-option v-for="item in ProjectFlow" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </div>
        <div v-if="!standard">
          <div class="formName">锁定重复</div>
          <template>
            <el-select v-model="projectLocking" disabled placeholder="请选择">
              <el-option v-for="item in projectLockingArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>

        </div>
      </div>
      <h3>
        <div :class="titActive === 0 ? 'titActive' : ''" @click="switchover(0)">
          项目记忆库
        </div>
        <!-- <router-link to="/projectHome/interpreter"> -->
        <div :class="titActive === 1 ? 'titActive' : ''" @click="switchover(1)">
          项目术语库
        </div>
        <!-- <div :class="titActive === 2 ? 'titActive' : ''" @click="switchover(2)">
          项目流程
        </div> -->
      </h3>
      <!-- 记忆库table 开始-->
      <memoryBank v-if="titActive === 0" :memoryBankList="memoryBankList" :domain="domain" :domainCode="domainCode">
      </memoryBank>
      <!-- 记忆库table 结束-->

      <!-- 术语库table 开始-->
      <termBank v-if="titActive === 1" :TermBankList="TermBankList" :domain="domain" :domainCode="domainCode">
      </termBank>
      <!-- 术语库table 结束-->

      <!-- 项目流程 开始-->
      <projectFlow v-if="titActive === 2" :projectProcessType="projectProcessType" @onProgressType="onProgressType">
      </projectFlow>
      <!-- 项目流程 结束-->

      <div class="btn">
        <button class="themeGoBut" @click="submit">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import memoryBank from "@/views/project/projectParticulars/projectMemoryBank.vue";
import termBank from "@/views/project/projectParticulars/projectTermBank.vue";
import projectFlow from "@/views/project/projectParticulars/projectFlow.vue";
export default {
  name: "projectParticulars",
  props: ["rowName"],
  data () {
    return {
      titActive: 0,
      queryData: "",
      memoryBankList: [],
      TermBankList: [],
      projectProcessType: "",
      projectName: "",
      domain: "",
      domainCode: "",
      loadinginstace: "",
      deliveryTime: "",
      deliveryMinute: "",
      pickerOptions: {
        // 日期限制
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000;
        }
      },
      projectValue: '',//项目流程
      ProjectFlow: [{
        value: "1",
        label: '翻译'
      }, {
        value: "2",
        label: '翻译+审校'
      }, {
        value: "3",
        label: '翻译+审校+复审'
      },],
      projectLocking: "",//项目锁定
      projectLockingArr: [{
        value: "1",
        label: '锁定重复句段'
      }, {
        value: "0",
        label: '不锁定重复句段'
      }],//项目锁定
    };
  },
  components: {
    memoryBank,
    termBank,
    projectFlow
  },
  computed: {
    start () {
      let time = "00:00"
      if (this.deliveryTime == "") {
        return
      }
      if (new Date(this.deliveryTime.replace(/-/g, '/')).getTime() < Date.now()) {
        let minu = new Date().getMinutes();
        let hour = new Date().getHours();
        if (minu >= 30) {
          minu = "00"
          hour = ++hour
        } else {
          minu = "30"
        }
        time = hour + ":" + minu
      }
      return time;
    }
  },
  created () {
    if (process.env.VUE_APP_NAME !== "hospital") {
      this.standard = false //true
    } else {
      this.standard = false
    }
    this.loadinginstace = this.$loading({ fullscreen: true });
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    console.log(this.queryData, '项目详情')

    this.projectValue = this.queryData.row.projectProcessType + ""
    this.projectLocking = this.queryData.row.ifRepeatLock + ""
    // this.projectLocking = "1"
    // this.projectValue = "1"
    this.getMemoryBankList();
  },
  methods: {
    // 返回上一页
    backtrack () {
      this.$router.go(-1);
    },
    // 切换选项卡
    switchover (data) {
      this.titActive = data;
    },
    // 项目流程
    onProgressType (data) {
      data ? (this.projectProcessType = 1) : (this.projectProcessType = 2);
    },
    // 获取项目信息
    getMemoryBankList () {
      var that = this;
      let params = {
        id: this.queryData.projectId
      };
      this.catReq1Service(
        `/api/v1/project/queryProjectTermMemoryList`,
        params
      ).then(function (response) {
        that.loadinginstace.close(); // loading清除
        if (!response.success) {
          that.loading = false;
          return;
        }
        let data = response.result;
        that.memoryBankList = data.memoryLibRespVoList || [];
        that.memoryBankList.forEach(item => {
          item.isEnable = Boolean(item.isEnable);
        });
        that.TermBankList = data.transTermLibRespVoList || [];
        that.TermBankList.forEach(item => {
          item.isEnable = Boolean(item.isEnable);
        });
        that.projectProcessType = data.projectProcessType;
        that.projectName = data.name;
        that.domain = data.domain;
        that.domainCode = data.domainCode;
        let timeAry = data.deliveryTime.trim().split(/\s+/);
        that.deliveryTime = timeAry[0];
        that.deliveryMinute = timeAry[1];
      });
    },
    // 保存
    submit () {
      let that = this;
      let memoryLibIdList = [],
        transTermLibIdList = [];
      this.projectName = this.projectName.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      if (!this.detection(this.projectName, 160, "项目名称")) {
        return;
      }
      let time = `${this.deliveryTime} ${this.deliveryMinute}:00`
      if (new Date(time).getTime() < new Date().getTime()) {
        that.$message.closeAll();
        that.$message({
          message: "交付时间不得小于当前时间",
          type: "warning"
        });
        return
      }
      this.memoryBankList.forEach(item => {
        // 获取记忆库id集合
        if (item.isEnable) {
          memoryLibIdList.push(item.id);
        }
      });
      this.TermBankList.forEach(item => {
        // 获取术语库id集合
        if (item.isEnable) {
          transTermLibIdList.push(item.id);
        }
      });
      let params = {
        id: this.queryData.projectId,
        memoryLibIdList,
        transTermLibIdList,
        name: this.projectName,
        projectProcessType: this.projectProcessType,
        deliveryTime: time
      };
      this.catReq1Service(`/api/v1/project/updateTransProject`, params).then(
        function (response) {
          if (!response.success) {
            that.loading = false;
            return;
          }
          that.$message.closeAll();
          that.$message({
            message: "保存成功!",
            type: "success"
          });
        }
      );
    }
  }
};
</script>
<style lang="less" scoped>
.projectParticulars {
  height: 100%;
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    .returnBtn {
      width: 48px;
      height: 30px;
      line-height: 30px;
      background: #02A4FD;
      color: #fff;
      position: absolute;
      left: 30px;
      top: 50%;
      margin-top: -15px;
      font-size: 18px;
    }
    p {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .main_box {
    height: calc(100% - 40px);
    // width: 1660px;
    position: relative;
    // min-height: 789px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 38px;
    padding: 0 20px;
    padding-top: 10px;
    box-sizing: border-box;
    .btn {
      position: absolute;
      // bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 30px;
      button {
        // width: 90px;
        // height: 36px;
        // background: #454545;
        // border: 1px solid rgba(69, 69, 69, 1);
        // box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
        // border-radius: 4px;
        // color: rgba(255, 255, 255, 1);
        margin: 30px;
      }
      // button:hover {
      //   background: #3e3e3e;
      // }
      // button:active {
      //   background: #333333;
      // }
    }
    .projectName {
      display: flex;
      justify-content: flex-start;
      div {
        display: flex;
        justify-content: space-between;
        .formName {
          margin: 0 20px;
          line-height: 36px;
        }
      }
      color: #333333;
      height: 36px;
      .data_now {
        display: flex;
        border-bottom: 1px solid #999999;
        // margin-left: 100px;
        /deep/.el-input {
          width: 103px;
        }
        /deep/.el-input__inner {
          width: 135px;
          border: none;
          // border-bottom: 2px solid #999999;
        }
      }
      span {
        float: left;
        height: 36px;
        line-height: 36px;
        margin-left: 10px;
      }
      .formName {
        margin-left: 60px;
      }
      .el-input {
        //  width: 100px;
        width: 178px;
        float: left;
        /deep/.el-input__inner {
          border: 0px;
          border-bottom: 1px solid #333333;
          border-radius: 0px;
        }
      }
    }
    .setBox_bottom {
      display: flex;
      justify-content: flex-start;
      margin-top: 20px;
      div {
        display: flex;
        justify-content: space-between;
        .formName {
          margin: 0 20px;
          line-height: 36px;
        }
      }
      .el-select {
        width: 180px;
        /deep/.el-input {
          width: 180px;
        }
      }
    }
    h3 {
      //   text-align: left;
      height: 30px;
      padding-top: 12px;
      margin-bottom: 1px;
      div {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        width: 92px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titActive {
        border-bottom: 1px solid #0288D2;
        color: #0288D2;
      }
    }
    .cell input {
      width: 54px;
    }
    // 表格样式开始
    /deep/.el-table {
      height: 100%;
      overflow-y: auto;
      .el-table__empty-block {
        // 修改无数据 出现滚动条
        height: 90% !important;
      }
    }
    .el-table {
      // margin: 10px auto;
      // height: 100%;
      overflow: auto;
      .el-date-editor.el-input {
        // 截止时间
        width: 140px;
      }
      /deep/.el-input__icon {
        line-height: 24px;
      }
      /deep/.el-input__inner {
        height: 26px;
        line-height: 24px;
        text-align: center;
      }
      input {
        width: 54px;
      }
      /deep/.row-expand-cover .el-table__expand-icon {
        visibility: hidden;
      }

      /deep/th {
        text-align: center;
      }
      /deep/.el-table__expanded-cell {
        padding: 0;
        padding-left: 20px;
        border-bottom: 0px;
      }
      /deep/.el-table__expanded-cell:hover {
        background: #fff !important;
      }
    }
    /deep/.el-table::before {
      height: 0px;
    }
    /deep/.el-input-number__increase {
      height: 13px !important;
    }
    /deep/.el-table th.is-leaf {
      border-bottom: 0px;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr {
      // background: rgba(241, 241, 241, 1);
      // margin-bottom: 30px;
      position: relative;
    }
    /deep/.el-table tbody tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5) !important;
      z-index: 1000;
      .operation {
        display: block;
        height: 23px;
      }
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }

    // /deep/.el-table td,
    //   .el-table th {
    //     // 修改table行高
    //     padding: 11px 0px !important;
    //   //   height: 36px !important;
    //     font-size: 12px;
    //   }
    /deep/.el-table td {
      border-bottom: 0px solid #ffff;
      text-align: center;
      font-size: 12px;
    }
    /deep/.el-table__body-wrapper {
      //   height: calc(100% - 50px);
      overflow-y: auto;
    }

    //   /deep/.el-table td:nth-child(2) {
    //     // text-align: left;
    //     .cell {
    //       overflow: hidden;
    //       text-overflow: ellipsis;
    //       white-space: nowrap;
    //     }
    //   }
    //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
    //     text-align: center;
    //   }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    // 表格样式结束
  }
  .domain {
    margin-left: 60px !important;
  }
}
</style>
<style lang="less">
.projectParticulars {
  .el-table__body-wrapper {
    overflow-y: auto;
    height: calc(100% - 65px);
  }
  // switch滑块开始
  .el-switch__core:after {
    top: -5px;
    left: -2px;
    width: 19px;
    height: 19px;
    // background:rgba(40,194,217,1);
    // border: rgba(40,194,217,1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .el-switch__core {
    height: 13px;
  }
  /deep/.el-switch {
    .el-switch__core {
      border-color: #29c0d5 !important;
    }
  }
  // switch滑块结束
}
</style>
